import React, { useEffect, useState } from "react";
import { CancelIcon, SearchesCIcon } from "../assets/SvgIcons";
import ProjectCard from "./Pages/Project/ProjectCard";
import CreateProjectModal from "./Pages/Modal/projectModal";
import ProjectLoadCard from "./Pages/Project/ProjectLoadCard";

const sampleData = [
  {
    uuid: "abc123",
    name: "Marketing Demo",
    createdAt: new Date().toISOString(),
    preview: true,
    published: true,
    owner: {
      name: "Alice Johnson",
      avatar: "",
    },
    scenes: [
      {
        inventory: {
          path: "https://via.placeholder.com/300x200",
        },
      },
    ],
    allocations: [
      {
        type: "OWNER",
      },
    ],
  },
  {
    uuid: "xyz789",
    name: "Training Module",
    createdAt: new Date().toISOString(),
    preview: false,
    published: false,
    owner: {
      name: "Bob Smith",
      avatar: "",
    },
    scenes: [],
    allocations: [
      {
        type: "EDITOR",
      },
    ],
  },{

    uuid: "123e4567-e89b-12d3-a456-426614174000",
  name: "Demo Project with All Options",
  createdAt: "2025-04-01T10:30:00Z",
  preview: true,
  published: true,
  owner: {
    name: "Jane Doe",
    avatar: "https://i.pravatar.cc/100?img=5",
  },
  allocations: [
    {
      type: "OWNER",
    },
    {
      type: "EDITOR",
    },
  ],
  scenes: [
    {
      inventory: {
        path: "https://via.placeholder.com/400x225.png?text=Demo+Thumbnail",
      },
    },
  ],
}
];

const View = () => {
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
 

  useEffect(() => {
    setList(sampleData);
  }, []);

  const showDashboard = false;

  const handleEnableShareProject = (projectData) => {
    alert(`Share project: ${projectData.name}`);
  };

  const confirmMoveToTrash = (uuid, actionType) => {
    alert(`Action: ${actionType} on project ID ${uuid}`);
  };

  return (
    <>
      <div className="view-list">
        <div className="row pt-3 mb-3 ps-0">
          <div className="col-md-6">
            <form className="app-search app-search1 d-flex justify-content-start">
              <div className="position-relative">
                <SearchesCIcon />
                <span className="searchiconcancel" onClick={() => setSearch("")}>
                  <CancelIcon />
                </span>
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value.toLowerCase())}
                  type="text"
                  name="searchName"
                  className="form-control"
                  placeholder="Search"
                  autoComplete="off"
                />
              </div>
            </form>
          </div>
          {/* <div className="col-md-6 d-flex align-items-center justify-content-end">
            <button className="redstandardbtn" onClick={openCreateModal}>
              New Project{" "}
            </button>
          </div> */}
        </div>

        <div className="main-list">
          {list
            .filter((e) => e.name.toLowerCase().includes(search))
            .map((e) => (
              <ProjectCard
                key={e.uuid}
                projectData={e}
                showDashboard={showDashboard}
                handleEnableShareProject={handleEnableShareProject}
                confirmMoveToTrash={confirmMoveToTrash}
              />
            ))}
          <ProjectLoadCard />
          <ProjectLoadCard />
          <ProjectLoadCard />
          <ProjectLoadCard />
        </div>

    
      </div>
    </>
  );
};

export default View;
